import { ApiError } from "../api";
import { mapRequestOutcome } from "./outcome";

const CODES = [
  "evaluation_source_changed",
  "evaluation_window_open",
  "evaluation_envelope_unsupported",
  "evaluation_opening_required",
  "evaluation_closure_required",
  "evaluation_auction_documents_required",
  "evaluation_publication_required",
  "evaluation_no_eligible_offers",
  "event_projection_unavailable",
  "evaluation_work_invalid",
  "evaluation_work_required",
  "evaluation_work_changed",
  "evaluation_decision_required",
  "evaluation_offer_expired",
  "evaluation_compliance_required",
  "award_allocation_invalid",
] as const;
export type EvaluationFeedback =
  | (typeof CODES)[number]
  | ReturnType<typeof mapRequestOutcome>
  | "storage"
  | "blocked";
export function evaluationFeedback(error: unknown): EvaluationFeedback {
  if (error instanceof ApiError) {
    if (error.kind === "cancelled") return "unknown";
    if (CODES.includes(error.code as (typeof CODES)[number]))
      return error.code as (typeof CODES)[number];
  }
  return mapRequestOutcome(error);
}
